import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IRemoteRefreshSchedule } from '../../../ts/ServerApi/types/IRemoteRefreshSchedule';

export interface IUpdateRemoteRefreshScheduleParams {
  targetId: string;
  initial:  IRemoteRefreshSchedule;
  final:  IRemoteRefreshSchedule;
}

export class UpdateRemoteRefreshScheduleRequest extends Request<IUpdateRemoteRefreshScheduleParams, IResult> {
  constructor(params: IUpdateRemoteRefreshScheduleParams) {
    super('updateRemoteRefreshSchedule', params);
  }
}
